import React, { FC, useEffect, useState } from 'react';
import useTimeSlots from 'hooks/useTimeSlots';
import { Grid, Typography, Button, Theme,useMediaQuery,useTheme} from '@mui/material';
import { useStore } from 'store/StoreProvider';
import { createStyles, makeStyles } from "@mui/styles";
import Slider from 'react-slick';
import CustomPrevArrow from './components/leftArrow';
import CustomNextArrow from './components/rightArrow';
import { useSession } from 'hooks/SessionProvider';
import Line from '@mui/icons-material/HorizontalRule';
import { useRoute } from 'hooks/RouteProvider';
import { customRoutes } from 'utils/constants';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    timeSlotMain: {
      border: "1px solid #d6d6d6",
      borderRadius: "10px",
      minHeight: "35px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      [theme.breakpoints.up('md')]: {
        marginBottom: "8px"
      },
      cursor: "pointer", 
      '&:hover': {
        backgroundColor: "#3D5A80", // Change background color on hover
        '& $timeFonts': {
          color: "#fff", // Change text color on hover for timeFonts class
        },
      },
      [theme.breakpoints.down('md')]:{
       marginTop:"20px",
       marginBottom:"20px",
      }
    },
    timeFonts: {
      color: "#3D5A80"
    },
    timeSlotsMobile:{
        [theme.breakpoints.down('md')]:{
            display:"flex",
            gap:"5px"
        }
    },
    timeSlotsBody:{
      [theme.breakpoints.down('md')]:{
        marginTop:"20px",
        width:"79%",

      },
      width:"100%"
    },
    timeSlotMobile:{
      [theme.breakpoints.down('md')]:{
        paddingLeft:"5px",
        paddingRight:"5px",
        width:"30%"
      }
    },
    slickSlider: {
      position: 'relative',
      display: 'block',
      boxSizing: 'border-box',
      '-webkit-touch-callout': 'none',
      '-webkit-tap-highlight-color': 'transparent',
      '& .slick-list': {
        overflow: 'hidden',
        margin: 0,
        padding: 0,
        position: 'relative',
        display: 'block',
        '& .slick-track': {
          display: 'flex',
          alignItems: 'center',
          marginLeft: 'auto',
          marginRight: 'auto',
          transform: 'translate3d(0, 0, 0)',
        },
      },
      '& .slick-arrow': {
        position: 'absolute',
        top: '50%',
        transform: 'translateY(-50%)',
        zIndex: 1,
        padding: 0,
        width: '30px',
        height: '30px',
        background: 'none',
        border: 'none',
        cursor: 'pointer',
        '&:before': {
          content: '""',
          display: 'none',
        },
      },
      '& .slick-prev': {
        left: '-35px',
      },
      '& .slick-next': {
        right: '-35px',
      },
    }
  })
);

interface Props {
  matchSchedules?: any;
  setFoundSchedules?:any;
  doctorId: number;
  addressID?:number
  onLoadComplete: () => void; // Callback prop
  loading?:boolean;
  duration:number
}

const TimeSlots: FC<Props> = ({ matchSchedules,setFoundSchedules,doctorId,addressID,onLoadComplete,loading,duration}) => {
  const classes = useStyles();
  const store = useStore();
  const getDateTime=store.getSelectedDateTime();
  const theme = useTheme();
  const data = store.getData();
  const { setIsDateTimeSelected} = useSession();
  const { navigate } = useRoute(); // Hook to navigate between routes

  const getAppointmentType = (id: number): any => {
    return data?.AppointmentTypes.find((appt: { id: number; }) => appt.id === id) || 1;
  }
  const participants=getAppointmentType(getDateTime?.appointmentTypeID).participants;
// Add Dynamic Duration here
  const timeSlots = useTimeSlots(matchSchedules,duration || 30,participants||1,data?.start_datetime,data?.hours_to_skip_schedules);

  useEffect(()=>{
    setFoundSchedules(timeSlots)
  },[timeSlots])  
  const[isShowAll,setIsShowAll]=useState(false)
  const displayedSlots = isShowAll ? timeSlots : timeSlots.slice(0, 3);
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'));
  const isTablet = useMediaQuery(theme.breakpoints.between('sm', 'md'));
  const linesLookup = [0,3, 2, 1]; 
  const settings = {
    infinite: false,
    speed: 500,
    slidesToShow: isTablet ? 3:2,
    slidesToScroll: 1,
    vertical:false,
    verticalSwiping: false ,
    arrows: true,
    prevArrow: <CustomPrevArrow classes={classes} />,
    nextArrow: <CustomNextArrow classes={classes} />,
  };

  const slotsToRender = timeSlots.length > 4 ? displayedSlots : timeSlots;

  useEffect(()=>{
    if(timeSlots&&timeSlots.length>=0)
    {
      const timer = setTimeout(() => {
        onLoadComplete();
      }, 300);
      return () => clearTimeout(timer);
    }
  },[timeSlots,matchSchedules])
  const selectedDateTime=(date:string,time:string,dateTimeOffset:string)=>{
    store.setSelectedDateTime({...store.getSelectedDateTime(),doctorId, date, time,dateTimeOffset});
    setIsDateTimeSelected(true)
    navigate(customRoutes.appointmentForm)
  }
  const renderTimeSlot = (item: any, index: number) => {
    const selectedMatch=item?.dateTimeOffset === getDateTime?.dateTimeOffset && addressID === getDateTime?.addressID &&
    doctorId === getDateTime?.doctorId;
    return (
      <Grid className={classes.timeSlotMobile} key={index} onClick={()=>{selectedDateTime(item?.date,item?.time,item?.dateTimeOffset)}}>
      <Grid className={classes.timeSlotMain} sx={{backgroundColor:`${selectedMatch && "#3D5A80"}`}}>
        <Typography variant='body2' className={classes.timeFonts} sx={{color:`${selectedMatch && "#fff"}`, fontFamily: 'Open Sans !important', }}>{item?.time}</Typography>
      </Grid>
    </Grid>
    )
  };

  const renderLines = (count:number) => {
    return Array.from({ length: count }, (_, index) => (
      <Grid item key={index} sx={{ height: '35px', marginBottom: '8px', display: 'flex', justifyContent: 'center', paddingTop: "7px", alignItems: "center" }}>
        <Line sx={{color:"#d2d5df"}}></Line>
      </Grid>
    ));
  };


  const renderMoreButton = () => (
    <Grid className={classes.timeSlotMobile} key="more">
      <Grid className={classes.timeSlotMain} onClick={() => setIsShowAll(!isShowAll)}>
        <Typography variant='body2' className={classes.timeFonts}>{isShowAll?"less":"more"}</Typography>
      </Grid>
    </Grid>
  );

  if(!loading && slotsToRender.length)
  {
    return (
      <Grid className={classes.timeSlotsBody}>
        {isSmallScreen ? (
          <Slider {...settings} className={classes.slickSlider}>
            {slotsToRender.map(renderTimeSlot)}
            {timeSlots.length > 4 && renderMoreButton()}
          </Slider>
        ) : (
          <Grid className={classes.timeSlotsMobile}>
            {slotsToRender.map(renderTimeSlot)}
            {timeSlots.length > 4 && renderMoreButton()}
            {renderLines(linesLookup[timeSlots.length])} 
            {
              timeSlots.length===0&&renderLines(4)
            }
          </Grid>
        )}
      </Grid>
    );
  } else return <Grid sx={{ minHeight: { xs: "95px" } }} />;
}

export default TimeSlots;
